import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { AbsencePage } from './containers/Pages/Dashboard/Absence/AbsencePage';
import CustomerById from './containers/Pages/Dashboard/Customers/[Id]';
import Customers from './containers/Pages/Dashboard/Customers/Overview';
import { DeployabilityPage } from './containers/Pages/Dashboard/Deployability/DeployabilityPage';
import { PaymentsPage } from './containers/Pages/Dashboard/Payments/PaymentsPage';
import Reviews from './containers/Pages/Dashboard/Reviews';
import Routes from './containers/Pages/Dashboard/Routes';
import { DefaultAuthState } from './core-module/models/redux/DefaultAuthState';
import { AppState } from './core-module/redux/reducers';
import { ConditionedRoute } from './components/ConditionedRoute/ConditionedRoute';
import { AppsRedirect } from './components/AppsRedirect/AppsRedirect';

interface DashboardRouterProps extends RouteComponentProps {
  match: any;
  auth: DefaultAuthState;
}

class AdminDashboardRouter extends React.Component<DashboardRouterProps, {}> {
  render() {
    const { match } = this.props;

    return (
      <Fragment>
        <Switch>
          <ConditionedRoute
            exact={true}
            path={`${match.url}/`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={() => <AppsRedirect to={'/app'} />}
          />
          <ConditionedRoute
            path={`${match.url}/routes`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={Routes}
          />
          <ConditionedRoute
            path={`${match.url}/afwezigheid`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={AbsencePage}
          />
          <ConditionedRoute
            path={`${match.url}/maaltijdbeoordelingen`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={Reviews}
          />
          <ConditionedRoute
            path={`${match.url}/betalingen`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={PaymentsPage}
          />
          <ConditionedRoute
            path={`${match.url}/klanten/:id`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={CustomerById}
          />
          <ConditionedRoute
            exact={true}
            path={`${match.url}/klanten`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={Customers}
          />
          <ConditionedRoute
            path={`${match.url}/inzetbaarheid`}
            alternatePath={`/geen-toegang`}
            condition={true}
            component={DeployabilityPage}
          />
        </Switch>
      </Fragment>
    );
  }
}

const mapPropsToDispatch = (state: AppState) => {
  return { auth: state.auth };
};

export default connect(mapPropsToDispatch)(withRouter(AdminDashboardRouter));
